module.exports = __webpack_public_path__ + "img/arrows-left.5b13a878.svg";